import { surfaceAuthCard } from '@/theme/designTokens'

/** Figma 5198-10358 — avatar profile dropdown */
export const providerProfileMenuPaperSx = {
  width: 212,
  maxWidth: 'calc(100vw - 32px)',
  bgcolor: surfaceAuthCard,
  backgroundColor: surfaceAuthCard,
  borderRadius: '10px',
  boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1), 0px 4px 6px -4px rgba(0,0,0,0.1)',
  overflow: 'hidden',
  mt: '20px',
  py: '12px',
  px: 0,
} as const

export const providerProfileMenuListSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
  p: 0,
  m: 0,
  listStyle: 'none',
} as const

export const providerProfileMenuItemSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
  width: '100%',
  border: 'none',
  borderRadius: '10px',
  bgcolor: 'transparent',
  cursor: 'pointer',
  py: '8px',
  px: '12px',
  boxSizing: 'border-box',
  textAlign: 'left',
  font: 'inherit',
  color: '#000000',
  transition: 'background-color 150ms ease',
  '&:hover': { bgcolor: '#DBEAFE' },
  '&:focus-visible': {
    outline: '2px solid #008CD0',
    outlineOffset: 2,
  },
  '&:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
} as const

export const providerProfileMenuLabelSx = {
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  color: '#000000',
} as const

/** Unverified — first menu item banner + Verify Me */
export const providerProfileVerifyBannerSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  width: '100%',
  boxSizing: 'border-box',
  bgcolor: '#FFF7ED',
  border: '1px solid #FED7AA',
  borderRadius: '10px',
  px: '10px',
  py: '10px',
} as const

export const providerProfileVerifyBannerTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  color: '#9A3412',
} as const

export const providerProfileVerifyBannerBtnSx = {
  textTransform: 'none',
  bgcolor: '#008CD0',
  color: '#FFFFFF',
  borderRadius: '8px',
  minHeight: 36,
  py: '6px',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '18px',
  boxShadow: 'none',
  '&:hover': { bgcolor: '#0077B3', boxShadow: 'none' },
} as const
